import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
// import FAQs from './pages/FAQs.jsx';
// import Privacy from './pages/Privacy.jsx';
import './MediaQuery.css';
// import TermsJuly from './pages/TermsMarch.jsx';
import TermsJune from './pages/TermsJune.jsx';
// import Accordion from './pages/Accordion.js';

const App = () => {
  return (
    // <div className='wrapper'>
    //             <Accordion />
    //           </div>
   
     <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <div className='App'>
        <Sidebar>
          <Routes>
            <Route path="/" element={<TermsJune />} />
            {/* <Route index path="/privacy-policy" element={<Privacy />} /> */}
            {/* <Route path="/faqs" element={<FAQs />} /> */}
            {/* <Route path="/faqs" element={<Accordion />} /> */}
          </Routes>
        </Sidebar>
      </div>
    </BrowserRouter> 

  );
};

export default App;